import type { RouteObject } from 'react-router';

import { InboxPage } from './Inbox';

/**
 * The operator's inbox. One `RouteObject`, so the file is `.route.tsx`
 * singular.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so the route
 * adds no loader of its own. The guard decides **navigation**; every row this
 * page renders is scoped to the caller by `backend-notification` on the request
 * itself, with `user_id = current_user.id` forced in its service layer. There is
 * no endpoint at any role that returns a notification the caller did not
 * receive, and no query parameter that widens the scope — so the console holds
 * no ownership check of its own and must not grow one.
 *
 * It is the one route in this console reached from the **top bar** rather than
 * from the navigation column: the unread indicator announces state
 * continuously, and an indicator inside a closed disclosure is an indicator
 * nobody sees.
 */
export const inboxRoute: RouteObject = {
  path: 'inbox',
  element: <InboxPage />,
};
